import { footerGroups, siteName } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full px-4 py-6 md:px-6 md:py-8">
      <div className="mx-auto w-full max-w-[1200px] overflow-hidden rounded-2xl bg-secondary-900 text-background-100">
        <div className="grid grid-cols-1 gap-8 p-8 md:grid-cols-[1.4fr_1fr_1fr] md:gap-10 md:p-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-200/80">
              一个围绕《华丽的外出》整理的专题合集页：完整版在线观看、未删减高清资源与百度云分享，
              都收在同一条动线上。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["完整版", "未删减", "1080P", "百度云"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-background-200/85"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-xs font-medium tracking-[0.24em] text-background-300">
                {group.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.anchor}
                      className="text-sm text-background-100/85 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-secondary-700/70 px-8 py-5 sm:flex-row sm:items-center sm:justify-between md:px-10">
          <p className="text-xs text-background-300">
            © 2026 {siteName} · 影迷专题合集页
          </p>
          <p className="text-xs text-background-300">
            内容为静态展示整理，仅供影迷交流参考
          </p>
        </div>
      </div>
    </footer>
  );
}